export default __webpack_public_path__ + "static/media/KB국민.e4042b82.svg";